/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect } from 'react'
import { shape, func } from 'prop-types'
import { connect } from 'react-redux'
import CMSRenderer from 'components/cms/CMSModules'
import Loader from 'components/loader'
import './main-content.scss'
import { observerCallback, options, createTargetElement } from '../../services/utility/observer'

export const MainContent = (props) => {
  const {
    pageContent: data, dispatch, ...rest
  } = props

  useEffect(() => {
    const boxElList = document.querySelectorAll('div[data-module]')
    const observer = new IntersectionObserver(observerCallback(), options)
    boxElList.forEach((el) => {
      observer.observe(el)
    })
  }, [])

  return (
    <div className="main-content">
      <div
        className="menu-overlay"
        onClick={() => dispatch({ type: 'TOGGLE_NAV' })}
      />
      {data ? <CMSRenderer {...rest} contents={data.mainContent} /> : null}
    </div>
  )
}

MainContent.propTypes = {
  pageContent: shape({}).isRequired,
  dispatch: func.isRequired,
}

export default Loader('pageContent')(connect()(MainContent))



// WEBPACK FOOTER //
// ./components/main-content/index.js